import Script from 'next/script';

{/* <iframe style="border: none;" src="https://cards.producthunt.com/cards/testimonials/782913,782803,782630,782617" width="1000px" height="1000px" frameborder="0" scrolling="no" allowfullscreen></iframe> */}

export default function Producthunt() {
  return (
    <div className='bg-transparent' style={{backgroundColor: 'transparent !important'}}>
      <Script
        src="https://cards.producthunt.com/assets/embed.js"
        strategy="lazyOnload"
      />
      <iframe
        style={{ border: 'none', backgroundColor: 'transparent important!'}}
        src="https://cards.producthunt.com/cards/testimonials/782913,782803,782630,782617"
        width="100%"
        height="1000px"
        frameBorder="0"
        scrolling="no"
        allowFullScreen
      />
    </div>
  );
}